import {
  createStore,
  createHook,
  StoreActionApi,
  defaultRegistry,
} from "react-sweet-state";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import API from "api";
import { FUNCTION_NAME } from "constants/enum";
import { StoreAuth } from "stores/AuthenticationStore/authentication";
import { AuthenticationStates } from "stores/AuthenticationStore/authenticationType.d";
import { get } from "lodash";
import { ConfigurationState } from "./configurationType.d";

export const CONFIGURATION_STORE = "ConfigurationStore";
export type StoreApi = StoreActionApi<ConfigurationState>;

export const initialState: ConfigurationState = {
  deviceId: null,
  notifications: [],
  isEndSession: false,
  napasLimitAmount: 0,
};

export const actions = {
  setIsEndSession:
    (isEndSession: boolean) =>
    ({ setState, getState }: StoreApi) => {
      const prevState = getState();
      setState({
        ...prevState,
        isEndSession,
      });
    },
  getDeviceId:
    () =>
    async ({ getState, setState }: StoreApi) => {
      const fp = await FingerprintJS.load();
      const { visitorId } = await fp.get();

      setState({
        ...getState(),
        deviceId: visitorId,
      });
    },
  getNotification:
    () =>
    async ({ getState, setState }: StoreApi) => {
      try {
        const authStore = await defaultRegistry.getStore(StoreAuth);
        const { storeState } = authStore;

        const authStates: AuthenticationStates = storeState.getState();
        const notificationResponse = await API({
          functionName: FUNCTION_NAME.GET_NOTIFICATION_STICKY,
          method: "POST",
          headerOnBody: {
            userId: authStates.user.userId,
            cusId: authStates.user.custId,
            cusNo: authStates.user.custNo,
          },
        });

        const notifications = get(
          notificationResponse,
          "body.notificationStickies",
          []
        );

        setState({
          ...getState(),
          notifications,
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("getNotification failed (non-critical):", e);
      }
    },
  getNapasLimitedAmount:
    () =>
    async ({ getState, setState }: StoreApi) => {
      // Config load KHÔNG critical: lỗi (endpoint chưa migrate / url) không được làm crash app.
      try {
        const authStore = await defaultRegistry.getStore(StoreAuth);
        const { storeState } = authStore;

        const authStates: AuthenticationStates = storeState.getState();
        const napasLimitAmountResponse = await API({
          functionName: FUNCTION_NAME.GET_NAPAS_LIMITED_AMOUNT,
          method: "POST",
          headerOnBody: {
            userId: authStates.user.userId,
            cusId: authStates.user.custId,
            cusNo: authStates.user.custNo,
          },
        });

        const napasLimitAmount = get(
          napasLimitAmountResponse,
          "body.napasLimitedAmount",
          []
        );

        setState({
          ...getState(),
          napasLimitAmount,
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("getNapasLimitedAmount failed (non-critical, giữ default):", e);
      }
    },
};
export type Actions = typeof actions;

export const StoreConfig = createStore<ConfigurationState, Actions>({
  initialState,
  actions,
  name: CONFIGURATION_STORE,
});

export const storeKeyConfig = `${StoreConfig.key}@__global__`;

const useConfiguration = createHook(StoreConfig);

export default useConfiguration;
